import React from 'react';
import CRMDashboard from './CRMDashboard';

const CRM = () => {
  return <CRMDashboard />;
};

export default CRM;
